<template>
  <div style="width:100%;height:0; z-index: 10;" class="my-6 border-b-4 sm:border-b border-scanTxLine rounded" />
</template>
